import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import MypageleftArea from '../../component/MypageleftArea';
import consts from '../../libs/consts';


import { getBase64, getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Radios from '../../component/Radios';
import AddrSelector from '../../component/AddrSelector';
import Select from '../../component/Select';
import Checkbox from '../../component/Checkbox';

export default function Setoutside({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectFile = useRef(null);
    const selectFile2 = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);

    const [memberinfos, setmemberinfos] = useState('');
    const [lists, setlists] = useState([]);
    const [writeflag, setwriteflag] = useState(false);
    const [errmsg, seterrmsg] = useState(['', '']);

    const [title, settitle] = useState('');
    const [desc, setdesc] = useState('');
    const [selnoticeidx, setselnoticeidx] = useState('');
    const [uidx, setuidx] = useState('');
    const [files, setfiles] = useState([]);

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx }
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx, category_1: x?.category_1 }
    })

    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    const [category_1, setcategory_1] = useState(0);
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);
    const [category_2, setcategory_2] = useState(0);

    const [minizoomlevel, setminizoomlevel] = useState(1);
    const [miniorderselviewtype, setminiorderselviewtype] = useState(0);
    const [miniorderbuyviewtype, setminiorderbuyviewtype] = useState(0);
    const [miniordersteps, setminiordersteps] = useState([]);
    const [miniorderbuttonText, setminiorderbuttonText] = useState('간편 문의');
    const [miniorderbuttonTexterror, setminiorderbuttonTexterror] = useState('');
    const [minicustombanner, setminicustombanner] = useState(0);
    const [minipcbanner, setminipcbanner] = useState('');
    const [minimobilebanner, setminimobilebanner] = useState('');
    const [minipcbannerfiles, setminipcbannerfiles] = useState({});
    const [minimobilebannerfiles, setminimobilebannerfiles] = useState({});

    const [cityspopflag, setcityspopflag] = useState(false);
    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);
    const [seldamdang, setseldamdang] = useState('');
    const [damdanglist, setdamdanglist] = useState([]);
    const [checkvalues, setcheckvalues] = useState([]);
    const [allCheckValues, setallCheckValues] = useState([]);
    const [jp_item_send, setjp_item_send] = useState(1);



    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        setjp_item_send(memberinfos?.jp_item_send*1);
    }, [memberinfos]);
    

    const componyUpdateFunc = (values = 0) => {
        if(memberinfos?.jp_item_send*1 === 1 && values*1 === 0){
            const PopComponents = () => {
                return (
                    <div className='productsendArea' style={{ width: 420, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                        <div style={{ fontSize: 20, color: '#6164A5'}}><span style={{ color: 'orange'}}>아싸 점포거래소</span>에서 홍보를 중단합니다.</div>
                        <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 700}}>* 연동된 모든 매물이 아싸 점포거래소에서 미노출 됩니다.</div>
                        <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 700}}>* 아싸 점포거래소에 적용까지 최대 1시간이 소요 됩니다.</div>
                        <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 700, justifyContent: 'center'}}>* 문의: 모두의 매물 고객센터 또는 아싸점포거래소 고객센터</div>
                    </div>
                );
            }
            dispatch(
                open({
                    component: <PopComponents />,
                    title: '알림',
                    button: "홍보 중단하기",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(loadingflas({ loading: true }));
                        let sender = {
                            jp_item_send: 0
                        }
                        APIS.postData('/v1/auth/outsideupdate', sender).then(({ data }) => {
                            if(data){
                                dispatch(close());
                                getMemberinfo((e) => {
                                    setmemberinfos(e);
                                });
                            }
                        }).catch(({ response }) => {
                            //console.log('???');
                            dispatch(close());
                            dispatch(
                                open({
                                    component: response?.data?.msg,
                                    title: '알림',
                                    button: "확인",
                                    titleviewer: true,
                                    alert: true,
                                    onPress: () => {
                                        dispatch(close());  
                                    },
                                })
                            );
    
                            const { data } = response;
                        }).finally(() => {
                            dispatch(loadingflas({ loading: false }));
                        });   
                    },
                })
            );
        } else {
            dispatch(loadingflas({ loading: true }));
            let sender = {
                jp_item_send: 1
            }                
            APIS.postData('/v1/auth/outsideupdate', sender).then(({ data }) => {
                if(data){
                    getMemberinfo((e) => {
                        setmemberinfos(e);
                    });
                }
            }).catch(({ response }) => {
                const { data } = response;
                dispatch(close());
                dispatch(
                    open({
                        component: data?.msg,
                        title: '알림',
                        button: "확인",
                        titleviewer: true,
                        alert: true,
                        onPress: () => {
                            dispatch(close());  
                        },
                    })
                );
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });  
        }
        
    }


    return (
        <>
            <Layout header={false} actives={''}>
                <div className='mypagearea'>
                    <div >
                        <MypageleftArea pages={6} />
                    </div>
                    <div
                        className='padding32'
                        style={{
                            display: 'flex', flexDirection: 'column', gap: 20
                        }}
                    >
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            }}
                        >
                            <div className='pagetitle fontsize20 bolds'>외부 광고 설정</div>
                        </div>
                        <div className='pagetabs margint20'>
                            <button className='active' onClick={() => { navigate('/Setoutside') }}>아싸점포거래소</button>
                            {memberinfos?.level*1 === 3 &&
                            <button onClick={() => { navigate('/Setminihome') }}>미니홈</button>
                            }
                        </div>
                        
                        <div className='mypageinputsarea' style={{ gap: 16, marginTop: 20 }}>
                            <div className="inputtextviewtype2 ">
                                <div className='fontsize16 bolds'>아싸점포거래소 광고</div>
                                <div>
                                    <Radios
                                        linetype={'radioimg'}
                                        values={memberinfos?.jp_item_send*1}
                                        setvalues={(e) => {
                                            componyUpdateFunc(e*1);
                                        }} 
                                        namevalue={[{names: '켜기', values: 1}, {names: '끄기', values: 0}]}
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                    />
                                </div>
                            </div> 
                            <div className='fontsize16 ' style={{ width: '100%', textAlign: 'left', marginTop: 20 }}>
                                아싸점포거래소 광고 켜기 시 접수·임장 상태의 상업용 부동산 월세 매물 홍보가 시작됩니다.<br />
                                공개를 원하지 않는 매물은 매물 목록에서 <span className='bolds' style={{ color: 'red'}}>외부공개 OFF</span>를 선택해주세요.
                            </div>
                            <div className=' ' style={{ width: '100%', textAlign: 'left', color: '#EC6E00', marginTop: -10 }}>*아싸점포거래소 : 대한민국 자영업자 커뮤니티 아프니까 사장이다에서 운영중인 양도양수 플랫폼으로,<br />월간 200만여 명 이상이 방문 중.</div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

